import Butter from 'buttercms';
export const butter = Butter('524e8f87c116799a4e3c35882e35037e9c8834d2');